import { render, staticRenderFns } from "./PartnerConnectionRequestsList.vue?vue&type=template&id=4a15e733&scoped=true"
import script from "./PartnerConnectionRequestsList.vue?vue&type=script&lang=js"
export * from "./PartnerConnectionRequestsList.vue?vue&type=script&lang=js"
import style0 from "./PartnerConnectionRequestsList.vue?vue&type=style&index=0&id=4a15e733&prod&lang=stylus&scoped=true"
import style1 from "./PartnerConnectionRequestsList.vue?vue&type=style&index=1&id=4a15e733&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a15e733",
  null
  
)

export default component.exports